import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { FaSpinner, FaHome, FaSearch } from 'react-icons/fa';

const LogScreen = () => {
    // Filtros
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedEmitenteId, setSelectedEmitenteId] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('ALL'); // 'ALL' para carregar todos por padrão

    // Dados
    const [allLogs, setAllLogs] = useState([]);
    const [currentLogs, setCurrentLogs] = useState([]);
    const [emitentes, setEmitentes] = useState([]);

    // Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const [logsPerPage] = useState(15);
    const [totalPages, setTotalPages] = useState(0);

    const [loading, setLoading] = useState(false);
    const [loadingEmitentes, setLoadingEmitentes] = useState(false);

    const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;
    const navigate = useNavigate();

    const statusOptions = [
        { value: 'ALL', label: 'Todos os Status' },
        { value: 'OK', label: 'Sucesso' },
        { value: 'FAIL', label: 'Falha/Erro' },
    ];

    // const fetchLogs = async () => {
    //     // AQUI ESTÁ A MUDANÇA PRINCIPAL
    //     // Cria as strings de data/hora completas com base nos valores dos inputs da tela
    //     const startDateTime = startDate + ' 00:00:01';
    //     const endDateTime = endDate + ' 23:59:59';

    //     if (!selectedEmitenteId || !startDate || !endDate) {
    //         toast.error('Selecione um emitente e preencha as datas.');
    //         return;
    //     }
    //     setLoading(true);
    //     try {
    //         const { data } = await axios.get(
    //             // Use as novas variáveis com hora
    //             `${URL_BACKEND}/logs/${selectedEmitenteId}/${startDateTime}/${endDateTime}`,
    //             { headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` } }
    //         );
    //         if (Array.isArray(data)) {
    //             setAllLogs(data);
    //             setTotalPages(Math.ceil(data.length / logsPerPage));
    //             setCurrentPage(1);
    //             toast.success(`Logs carregados com sucesso! (${data.length} registros)`);
    //         } else {
    //             setAllLogs([]);
    //             setTotalPages(0);
    //             toast.error('Dados recebidos não estão no formato esperado.');
    //         }
    //     } catch (error) {
    //         console.error('Erro ao buscar logs:', error);
    //         toast.error(error.response?.data?.message || 'Erro ao carregar logs.');
    //         setAllLogs([]);
    //         setTotalPages(0);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // Efeito 1: Carrega emitentes e define os filtros padrão na montagem do componente

    const fetchLogs = async () => {
        // Cria as strings de data/hora completas com base nos valores dos inputs da tela
        const startDateTime = startDate + ' 00:00:01';
        const endDateTime = endDate + ' 23:59:59';

        // NOVO: Pega o status, ou usa 'ALL' se estiver vazio.
        const statusParam = selectedStatus || 'ALL';

        if (!selectedEmitenteId || !startDate || !endDate) {
            toast.error('Selecione um emitente e preencha as datas.');
            return;
        }
        setLoading(true);
        try {
            // Altere o endpoint para incluir o status como o último parâmetro
            const { data } = await axios.get(
                `${URL_BACKEND}/logs/${selectedEmitenteId}/${startDateTime}/${endDateTime}/${statusParam}`,
                { headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` } }
            );
            if (Array.isArray(data)) {
                setAllLogs(data);
                setTotalPages(Math.ceil(data.length / logsPerPage));
                setCurrentPage(1);
                toast.success(`Logs carregados com sucesso! (${data.length} registros)`);
            } else {
                setAllLogs([]);
                setTotalPages(0);
                toast.error('Dados recebidos não estão no formato esperado.');
            }
        } catch (error) {
            console.error('Erro ao buscar logs:', error);
            toast.error(error.response?.data?.message || 'Erro ao carregar logs.');
            setAllLogs([]);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchEmitentes = async () => {
            setLoadingEmitentes(true);
            try {
                const { data } = await axios.get(`${URL_BACKEND}/emitentesAll/999/999`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
                });
                setEmitentes(data);
            } catch (err) {
                console.error(err);
                toast.error('Erro ao carregar a lista de emitentes.');
            } finally {
                setLoadingEmitentes(false);
            }
        };

        const storedEmitenteId = localStorage.getItem('userIdEmitente');

        if (storedEmitenteId) {
            setSelectedEmitenteId(storedEmitenteId);

            const today = new Date();
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            // Variáveis para a data completa (com hora)
            const startDateTime = format(firstDayOfMonth, 'yyyy-MM-dd') + ' 00:00:01';
            const endDateTime = format(lastDayOfMonth, 'yyyy-MM-dd') + ' 23:59:59';

            // Você pode usar essas variáveis para a lógica de filtro de dados
            // E então, definir as variáveis de estado para os inputs com o formato 'YYYY-MM-DD'
            setStartDate(format(firstDayOfMonth, 'yyyy-MM-dd'));
            setEndDate(format(lastDayOfMonth, 'yyyy-MM-dd'));
        } else {
            toast.error('ID do emitente não encontrado. Faça login novamente.');
        }
        fetchEmitentes();
    }, [URL_BACKEND]);

    useEffect(() => {
        if (selectedEmitenteId && startDate && endDate) {
            fetchLogs();
        }
    }, [selectedEmitenteId, startDate, endDate, selectedStatus]);

    // Efeito 3: Atualiza os logs da página atual sempre que a lista de todos os logs ou a página muda
    useEffect(() => {
        const end = currentPage * logsPerPage;
        const start = end - logsPerPage;
        setCurrentLogs(allLogs.slice(start, end));
    }, [allLogs, currentPage, logsPerPage]);

    // Lógica da Paginação
    const goToNextPage = () => currentPage < totalPages && setCurrentPage(p => p + 1);
    const goToPreviousPage = () => currentPage > 1 && setCurrentPage(p => p - 1);
    const goToPage = (n) => setCurrentPage(n);

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const max = 5;
        let start = Math.max(1, currentPage - Math.floor(max / 2));
        let end = Math.min(totalPages, start + max - 1);
        if (end - start + 1 < max) start = Math.max(1, end - max + 1);
        for (let i = start; i <= end; i++) pageNumbers.push(i);

        return (
            <ul style={ui.paginationList}>
                {start > 1 && (
                    <>
                        <li style={ui.paginationItem} onClick={() => goToPage(1)}>
                            <button style={ui.paginationButton}>1</button>
                        </li>
                        {start > 2 && <li style={ui.paginationEllipsis}>…</li>}
                    </>
                )}
                {pageNumbers.map(n => (
                    <li key={n} style={ui.paginationItem} onClick={() => goToPage(n)}>
                        <button style={{ ...ui.paginationButton, ...(currentPage === n ? ui.paginationButtonActive : {}) }}>
                            {n}
                        </button>
                    </li>
                ))}
                {end < totalPages && (
                    <>
                        {end < totalPages - 1 && <li style={ui.paginationEllipsis}>…</li>}
                        <li style={ui.paginationItem} onClick={() => goToPage(totalPages)}>
                            <button style={ui.paginationButton}>{totalPages}</button>
                        </li>
                    </>
                )}
            </ul>
        );
    };

    // Função auxiliar para exibir o tipo de log
    const getLogType = (tipo) => {
        if (tipo?.toLowerCase().includes('email')) {
            return 'E-mail';
        }
        if (tipo?.toLowerCase().includes('whatsapp')) {
            return 'WhatsApp';
        }
        return 'Manual';
    };

    return (
        <div style={ui.page}>
            {/* Header */}
            <div style={ui.headerBar}>
                <h1 style={ui.headerTitle}>Histórico de Logs de Envio</h1>
                <button onClick={() => navigate('/dashboard')} style={ui.headerButton}>
                    <FaHome style={{ marginRight: 8 }} /> Voltar
                </button>
            </div>

            {/* Filtros */}
            <div style={ui.card}>
                <h3 style={ui.sectionTitle}>Filtros</h3>
                <div style={ui.filtersRow}>
                    <div style={ui.formGroup}>
                        <label style={ui.label}>Data Inicial</label>
                        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={ui.input} />
                    </div>
                    <div style={ui.formGroup}>
                        <label style={ui.label}>Data Final</label>
                        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={ui.input} />
                    </div>
                    <div style={ui.formGroup}>
                        <label style={ui.label}>Emitente</label>
                        <select
                            value={selectedEmitenteId}
                            onChange={e => setSelectedEmitenteId(e.target.value)}
                            style={ui.select}
                            disabled={loadingEmitentes}
                        >
                            {loadingEmitentes ? (
                                <option value="">Carregando...</option>
                            ) : (
                                <>
                                    <option value="">Selecione...</option>
                                    {emitentes.map(em => (
                                        <option key={em.id} value={em.id}>{em.nome}</option>
                                    ))}
                                </>
                            )}
                        </select>
                    </div>

                    {/* NOVO: Campo de Filtro de Status */}
                    <div style={ui.formGroup}>
                        <label style={ui.label}>Status</label>
                        <select
                            value={selectedStatus}
                            onChange={e => setSelectedStatus(e.target.value)}
                            style={ui.select}
                        >
                            {statusOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* Fim do novo campo */}

                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button onClick={fetchLogs} disabled={loading || loadingEmitentes} style={ui.buttonPrimary}>
                            {loading ? <><FaSpinner className="fa-spin" style={{ marginRight: 8 }} /> Buscando…</> : <><FaSearch style={{ marginRight: 8 }} /> Buscar Logs</>}
                        </button>
                    </div>
                </div>
            </div>

            {/* Tabela */}
            <div style={ui.card}>
                <h3 style={ui.sectionTitle}>Resultados</h3>

                {loading && <p style={ui.muted}>Carregando logs de envio…</p>}
                {!loading && allLogs.length === 0 && <p style={ui.errorText}>Nenhum log de envio encontrado com os filtros selecionados.</p>}

                {!loading && allLogs.length > 0 && (
                    <>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={ui.table}>
                                <thead>
                                    <tr>
                                        <th style={ui.th}>Data e Hora</th>
                                        <th style={ui.th}>Tipo</th>
                                        <th style={ui.th}>Destinatário</th>
                                        <th style={ui.th}>MSG</th>
                                        <th style={ui.th}>Status</th>
                                        <th style={ui.th}>Canal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentLogs.map((log) => (
                                        <tr key={log.id} style={ui.tr}>
                                            <td style={ui.td}>
                                                {log.sent_at ? format(parseISO(log.sent_at), 'dd/MM/yyyy HH:mm:ss') : '-'}
                                            </td>
                                            <td style={ui.td}>
                                                {/* {getLogType(log.tipo)} */}
                                                {log.tipo}
                                            </td>
                                            <td
                                                style={{
                                                    ...ui.td,
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                                title={log.nome}
                                            >
                                                {log.nome}
                                            </td>
                                            <td
                                                style={{
                                                    ...ui.td,
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                                title={log.error}
                                            >
                                                {log.error}
                                            </td>                                            <td style={ui.td}>
                                                <span style={log.status?.toLowerCase() === 'fail' || log.status?.toLowerCase() === 'erro' ? ui.badgeRed : ui.badgeGreen}>
                                                    {log.status}
                                                </span>
                                            </td>
                                            <td style={ui.td}>
                                                {log.canal}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {totalPages > 1 && (
                            <div style={ui.paginationContainer}>
                                <button onClick={goToPreviousPage} disabled={currentPage === 1} style={ui.paginationNav}>
                                    Anterior
                                </button>
                                {renderPageNumbers()}
                                <button onClick={goToNextPage} disabled={currentPage === totalPages} style={ui.paginationNav}>
                                    Próxima
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

// UI tokens – mantidos iguais aos seus arquivos
const ui = {
    page: { padding: 24, backgroundColor: '#f8fafc', minHeight: '95vh', width: '100%', maxWidth: '1200px', margin: '0 auto', boxSizing: 'border-box', marginBottom: 40 },
    headerBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 24, marginBottom: 24, border: '1px solid #e5e7eb', borderRadius: '16px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', boxShadow: '0 20px 40px rgba(0,0,0,0.15)', color: '#fff' },
    headerTitle: { margin: 0, fontSize: '1.5rem', fontWeight: 600 },
    headerButton: { backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', padding: '10px 16px', borderRadius: 10, border: '2px solid rgba(255,255,255,0.25)', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center' },
    card: { backgroundColor: '#ffffff', borderRadius: 12, border: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', padding: 20, marginBottom: 24 },
    sectionTitle: { margin: '0 0 16px 0', fontSize: '1.125rem', fontWeight: 600, color: '#1f2937', borderBottom: '2px solid #e5e7eb', paddingBottom: 8 },
    filtersRow: { display: 'flex', flexWrap: 'wrap', gap: 16 },
    formGroup: { display: 'flex', flexDirection: 'column', minWidth: 200, flex: 1 },
    label: { marginBottom: 6, fontWeight: 500, color: '#374151', fontSize: '0.875rem' },
    helpText: { fontSize: '0.75rem', color: '#6b7280', marginTop: 4, display: 'flex', alignItems: 'center' },
    input: { padding: '12px 16px', borderRadius: 8, border: '2px solid #e5e7eb', fontSize: '0.875rem', transition: 'all 0.2s ease', backgroundColor: '#ffffff', outline: 'none' },
    select: { padding: '12px 16px', borderRadius: 8, border: '2px solid #e5e7eb', fontSize: '0.875rem', backgroundColor: '#ffffff', cursor: 'pointer', outline: 'none', transition: 'all 0.2s ease' },
    buttonPrimary: { backgroundColor: '#667eea', color: '#ffffff', padding: '12px 16px', borderRadius: 8, border: '2px solid #667eea', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', display: 'flex', alignItems: 'center' },
    table: { width: '100%', borderCollapse: 'separate', borderSpacing: '0 8px' },
    th: { backgroundColor: '#e9ecef', padding: 8, textAlign: 'left', color: '#555', fontWeight: 'bold', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '2px solid #dee2e6' },
    tr: { backgroundColor: '#fdfdfe', transition: 'background-color 0.2s ease', minHeight: 45 },
    td: { padding: 8, borderBottom: '1px solid #e9ecef', color: '#495057', fontSize: '0.8rem', whiteSpace: 'nowrap', verticalAlign: 'middle', lineHeight: 1.3 },
    badgeGreen: { backgroundColor: '#d1fae5', color: '#065f46', padding: '4px 10px', borderRadius: 999, fontWeight: 700, fontSize: '0.75rem' },
    badgeRed: { backgroundColor: '#fee2e2', color: '#991b1b', padding: '4px 10px', borderRadius: 999, fontWeight: 700, fontSize: '0.75rem' },
    paginationContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20, gap: 10 },
    paginationNav: { backgroundColor: '#667eea', color: '#fff', padding: '10px 18px', borderRadius: 8, border: 'none', fontSize: '0.95rem', fontWeight: 'bold', cursor: 'pointer' },
    paginationList: { display: 'flex', listStyle: 'none', margin: 0, padding: 0, gap: 6 },
    paginationItem: { cursor: 'pointer' },
    paginationButton: { backgroundColor: '#f0f2f5', color: '#333', padding: '10px 15px', borderRadius: 8, border: '1px solid #ddd', fontSize: '0.95rem', minWidth: 40, cursor: 'pointer' },
    paginationButtonActive: { backgroundColor: '#667eea', color: '#fff', borderColor: '#667eea' },
    muted: { color: '#6b7280' },
    errorText: { color: '#ef4444', fontWeight: 600 },
};

export default LogScreen;